import React, { useMemo } from 'react';
import { DoughnutChart } from '../../../../common/charts';

const Charts = ({ allUsers }) => {
	const getCardsDistChartData = useMemo(() => {
		const colors = ['#a020e9', '#1badde', '#fc0000', '#4e4e4e', '#d3a43c'];
		const labels = ['purple', 'blue', 'red', 'black', 'royal'];
		const title = 'Cards Distribution';
		const data = [];
		const metaData = [];
		const activeUsers = allUsers.filter((u) => u.active === 'Yes');
		for (const i in labels) {
			const filtered = activeUsers.filter((u) => u.card === labels[i]);
			data.push(((filtered.length * 100) / activeUsers.length).toFixed(1));
			metaData.push(filtered.length);
		}
		const toolTipCB = ({ label, dataIndex, parsed }) =>
			`${label} Holders: ${metaData[dataIndex]} Persons (${parsed}%)`;

		return { colors, labels, data, toolTipCB, title };
	}, [allUsers]);

	const getActiveUsersChartData = useMemo(() => {
		const colors = ['#5514fb', '#fbc714'];
		const labels = ['Yes', 'No'];
		const title = 'Active/Inactive Users';
		const data = [];
		const metaData = [];
		const mmpUsers = allUsers.filter((u) => u.email);
		for (const i in labels) {
			const filtered = mmpUsers.filter((u) => u.active === labels[i]);
			data.push(((filtered.length * 100) / mmpUsers.length).toFixed(1));
			metaData.push(filtered.length);
		}
		const toolTipCB = ({ label, dataIndex, parsed }) =>
			`${label} Users: ${metaData[dataIndex]} Users (${parsed}%)`;

		return {
			colors,
			labels: ['Active', 'InActive'],
			data,
			toolTipCB,
			title,
		};
	}, [allUsers]);

	return (
		<div className='my-4 card myCards'>
			<div className='card-body'>
				<div className='row'>
					<div className='col-sm-4 offset-sm-1'>
						<DoughnutChart chartData={getCardsDistChartData} />
					</div>
					<div className='col-sm-4 offset-sm-1'>
						<DoughnutChart chartData={getActiveUsersChartData} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Charts;
